/* ==========================================================================
   Maison: global.js
   Header scroll state, dialog (drawer/search) handling, reveal-on-scroll
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLOSE_DELAY = reduceMotion ? 0 : 450;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Header: compact on scroll ------------------------------------------- */

  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var ticking = false;

    function update() {
      var y = window.scrollY || window.pageYOffset;
      // Hysteresis prevents flicker when the header height changes.
      if (y > 48) {
        header.classList.add('is-scrolled');
      } else if (y < 12) {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    update();
  }

  /* Dialogs: mobile drawer + search (native <dialog>) -------------------- */

  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        dialog.classList.add('is-open');
      });
    });
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var focusTarget = dialog.querySelector('[data-autofocus]');
    if (focusTarget) focusTarget.focus();
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-open');
    var openers = document.querySelectorAll('[aria-controls="' + dialog.id + '"]');
    for (var i = 0; i < openers.length; i++) {
      openers[i].setAttribute('aria-expanded', 'false');
    }
    window.setTimeout(function () {
      if (dialog.open) dialog.close();
    }, CLOSE_DELAY);
  }

  function initDialogs() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-dialog-open]');
      if (opener) {
        openDialog(document.getElementById(opener.getAttribute('data-dialog-open')), opener);
        return;
      }

      var closer = event.target.closest('[data-dialog-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      // Click on the backdrop area (the dialog element itself)
      if (event.target.matches && event.target.matches('dialog[data-dialog]')) {
        closeDialog(event.target);
      }
    });

    // Esc key: run the animated close instead of the instant one.
    document.addEventListener(
      'cancel',
      function (event) {
        if (event.target.matches && event.target.matches('dialog[data-dialog]')) {
          event.preventDefault();
          closeDialog(event.target);
        }
      },
      true
    );

    // If the viewport grows to desktop while the drawer is open, close it.
    var desktop = window.matchMedia('(min-width: 990px)');
    var onChange = function (e) {
      if (e.matches) {
        var drawer = document.querySelector('dialog[data-drawer][open]');
        if (drawer) drawer.close();
        if (drawer) drawer.classList.remove('is-open');
      }
    };
    if (desktop.addEventListener) {
      desktop.addEventListener('change', onChange);
    }
  }

  /* Reveal on scroll ----------------------------------------------------- */

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  function initReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-reveal]:not(.is-visible)');
    var inEditor = window.Shopify && window.Shopify.designMode;
    for (var i = 0; i < items.length; i++) {
      if (!observer || reduceMotion || inEditor) {
        items[i].classList.add('is-visible');
      } else {
        observer.observe(items[i]);
      }
    }
  }

  /* Cart count (used by the cart drawer in a later batch) ---------------- */

  function initCartCount() {
    document.addEventListener('cart:updated', function (event) {
      var count = event.detail && typeof event.detail.item_count === 'number' ? event.detail.item_count : null;
      if (count === null) return;
      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = count;
        badges[i].hidden = count === 0;
      }
      var links = document.querySelectorAll('[data-cart-link]');
      for (var j = 0; j < links.length; j++) {
        links[j].setAttribute('aria-label', 'Cart (' + count + ')');
      }
    });
  }

  onReady(function () {
    initHeader();
    initDialogs();
    initReveal();
    initCartCount();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
  });
})();